/**
 */
export function PageLoadingFallback() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        <div className="relative h-12 w-12">
          <div className="absolute inset-0 animate-spin rounded-full border-4 border-muted border-t-primary" />
        </div>
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    </div>
  );
}

/**
 */
export function ComponentLoadingFallback({ className }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center p-4 ${className ?? ''}`}>
      <div className="relative h-6 w-6">
        <div className="absolute inset-0 animate-spin rounded-full border-2 border-muted border-t-primary" />
      </div>
    </div>
  );
}

/**
 */
export function EditorBlockSkeleton({ height = 120 }: { height?: number }) {
  return (
    <div
      className="animate-pulse rounded-lg border border-border bg-muted/30"
      style={{ height }}
    >
      <div className="flex h-full items-center justify-center">
        <div className="h-4 w-4 animate-spin rounded-full border-2 border-muted-foreground/30 border-t-muted-foreground" />
      </div>
    </div>
  );
}
